import Breadcrumbs from "components/Common/Breadcrumb";
import React, { useCallback, useEffect, useState } from "react";
import { MetaTags } from "react-meta-tags";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Input,
  Row,
} from "reactstrap";
import {
  getUnitOfMeasurements,
  addNewUnitOfMeasurement,
  updateUnitOfMeasurement,
  getUnitOfMeasurementById,
  deleteUnitOfMeasurement,
  clearUnitOfMeasurementError,
} from "store/actions";
import ConfirmDeleteModal from "components/Common/ConfirmDeleteModal";
import { toastMessage } from "helpers/utils";

import { debounce } from "lodash";
import ModalForm from "containers/unit-of-measurement/ModalForm";
import UnitOfMeasurementTable from "containers/unit-of-measurement/UnitOfMeasurementTable";

const UnitOfMeasurementList = (props) => {
  const [id, setId] = useState(null);
  const [term, setTerm] = useState('')
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [modalEditIsOpen, setModalEditIsOpen] = useState(false);
  const [modalAddIsOpen, setModalAddIsOpen] = useState(false);
  const [modalConfirmDeleteIsOpen, setModalConfirmDeleteIsOpen] =
    useState(false);

  const { 
    getUnitOfMeasurements, 
    addNewUnitOfMeasurement, 
    deleteUnitOfMeasurement, 
    updateUnitOfMeasurement, 
    clearUnitOfMeasurementError, 
    getUnitOfMeasurementById, 
    message, 
    items, 
    item, 
    loading, 
    itemCount, 
    pageCount 
} = props;

const debouncedFetchData = useCallback(debounce(term =>{
    setTerm(term)
}, 1000), [])

  useEffect(() => {
    getUnitOfMeasurements({page, pageSize, term});
  }, [page, pageSize, term]);

  useEffect(() => {
    if (message) {
      toastMessage(message);
      clearUnitOfMeasurementError();
    }
  }, [message]);

  const handleOnEdit = id => {
    getUnitOfMeasurementById(id);
    setModalEditIsOpen(true);
  };

  const handleUpdate = supplier => {
    updateUnitOfMeasurement(supplier);
    setModalEditIsOpen(false);
  };

  const handleOnAddNew = () => {
    setModalAddIsOpen(true);
  };

  const handleSubmit = item => {
    addNewUnitOfMeasurement(item);
    setModalAddIsOpen(false);
  };

  const handleConfirmDelete = id => {
    setId(id);
    setModalConfirmDeleteIsOpen(true);
  };

  const handleDelete = () => {
    deleteUnitOfMeasurement(id);
    setModalConfirmDeleteIsOpen(false);
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Unit Of Measurement | CR TechSoft</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Unit Of Measurement" breadcrumbItem="Unit Of Measurement List" />
          <Row>
            <Col md={12}>
              <Card className="mb-1 rounded-3">
                <CardHeader className="bg-transparent border pb-0 pt-3">
                  <Row className="g-1">
                    <Col md={2}>
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <Input
                            type="text"
                            placeholder="Quick Search ..."
                            onChange={(e)=>{
                                debouncedFetchData(e.target.value)
                            }}
                          ></Input>
                          <i className="fas fa-search search-icon" />
                        </div>
                      </div>
                    </Col>
                    <Col md={2}></Col>
                    <Col md={2}></Col>
                    <Col md={2}></Col>
                    <Col md={4}>
                      <div className="text-sm-end">
                        <Button
                          type="button"
                          color="primary"
                          className="me-1"
                          onClick={handleOnAddNew}
                        >
                          <i className="fas fa-plus" /> Add New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
                <Collapse isOpen={false}>
                  <CardBody className="pb-1"></CardBody>
                </Collapse>
              </Card>
            </Col>
            <Col md={12}>
              {items && (
                <UnitOfMeasurementTable
                  items={items}
                  itemCount={itemCount}
                  page={page}
                  totalPage={pageCount}
                  loading={loading}
                  defaultPageSize={pageSize}
                  onEdit={handleOnEdit}
                  onConfirmDelete={handleConfirmDelete}
                  onChangePage={(page) => setPage(page)}
                  onPageSizeChange={(pageSize)=> {
                    setPage(1);
                    setPageSize(pageSize);
                  }}
                />
              )}
              {item && (
                <ModalForm
                  title={"Edit UoM"}
                  item={item}
                  isOpen={modalEditIsOpen}
                  toggle={()=> setModalEditIsOpen(!modalEditIsOpen)}
                  onSubmit={handleUpdate}
                />
              )}
              <ModalForm
                title={"Add UoM"}
                isOpen={modalAddIsOpen}
                toggle={()=>setModalAddIsOpen(!modalAddIsOpen)}
                onSubmit={handleSubmit}
              />
              <ConfirmDeleteModal
                title="Confirm Delete"
                isOpen={modalConfirmDeleteIsOpen}
                toggle={()=> setModalConfirmDeleteIsOpen(!modalConfirmDeleteIsOpen)}
                onSubmit={handleDelete}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

UnitOfMeasurementList.propTypes = {
  items: PropTypes.array,
  item: PropTypes.object,
  loading: PropTypes.bool,
  message: PropTypes.object,
  error: PropTypes.string,
  itemCount: PropTypes.number,
  pageCount: PropTypes.number,

  getUnitOfMeasurements: PropTypes.func,
  addNewUnitOfMeasurement: PropTypes.func,
  updateUnitOfMeasurement: PropTypes.func,
  getUnitOfMeasurementById: PropTypes.func,
  deleteUnitOfMeasurement: PropTypes.func,
  clearUnitOfMeasurementError: PropTypes.func,
};

const mapStateToProps = ({ unitOfMeasurement }) => {
  return unitOfMeasurement;
};

export default withRouter(
  connect(mapStateToProps, {
    getUnitOfMeasurements,
    addNewUnitOfMeasurement,
    updateUnitOfMeasurement,
    getUnitOfMeasurementById,
    deleteUnitOfMeasurement,
    clearUnitOfMeasurementError,
  })(UnitOfMeasurementList)
);
